import React from "react";

import createReactClass from 'create-react-class';
import PropTypes from "prop-types";
import BaseMixin from './BaseMixin';

import Select2 from "shared/react_components/Select2";
import NumberCompareTerminalMixin from "./NumberCompareTerminalMixin";

const Scorecard = createReactClass({
  displayName: 'Scorecard',
  mixins: [BaseMixin, NumberCompareTerminalMixin],

  propTypes: {
    node: PropTypes.object.isRequired,
    selectUrls: PropTypes.object.isRequired,
    editable: PropTypes.bool
  },

  render: function() {
    return (
      <form className="form-inline scorecard-terminal">
        {this.renderTerminalName()}
        {this._renderScorecardParamName()}
        {this.renderRelOp()}
        {this._renderValue()}
      </form>
    );
  },

  selectChangeListener: function(data) {
    this.props.node.set({
      partner_name: data.partner_name,
      friendly_name: data.text
    });
  },

  _renderScorecardParamName: function() {
    // initialize the text if model is already set
    var initialValue = this.props.node.get('partner_name');
    if (initialValue) {
      this.props.node.set("partner_name_label", initialValue, { silent: true });
    }

    if (this.props.editable) {
      return (
        <Select2
          uniqueNameField ='partner_name'
          friendlyNameField='friendly_name'
          node={this.props.node}
          url={this.props.selectUrls.fieldsApiUrl + "&data_type=score"}
          changeListener={this.selectChangeListener}
          style={ { marginRight: '5px', verticalAlign: 'middle' } }
        />
      );
    } else {
      return this._renderReadonlyValue(initialValue);
    }
  },

  _renderValue: function() {
    return (<input
      className="form-control"
      style={this._valueStyles()}
      value={this.props.node.get('value')}
      onChange={this.onValueChange}
      disabled={!this.props.editable} />
    );
  },

  onValueChange: function(evt) {
    this.props.node.set('value', this._sanatizeInput(evt.target.value));
  },

  _sanatizeInput: function(input) {
    return parseInt(input) || 0;
  }
});

export default Scorecard;
